var _templateObject, _templateObject2, _templateObject3;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { Fragment } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Flex } from '@finect/tabular-core/Flex';
import { X } from '@finect/tabular-icons/x';
import { Icon } from '@finect/tabular-components/Icon';
import { UserMenu } from './UserMenu';
import { AccessButton } from './partials/AccessButton';
const appearIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const appearOut = keyframes(["100%{opacity:0;}0%{opacity:1;}"]);
const appearInAnimation = css(["animation:", " 0.25s ease-in;"], appearIn);
const appearOutAnimation = css(["animation:", " 0.25s ease-in;"], appearOut);
const slideIn = keyframes(["0%{transform:translateX(125%);}100%{transform:translateX(0);}"]);
const slideOut = keyframes(["100%{transform:translateX(125%);}0%{transform:translateX(0);}"]);
const slideInAnimation = css(["animation:", " 0.3s cubic-bezier(0.49,0.42,0.52,0.98);"], slideIn);
const slideOutAnimation = css(["animation:", " 0.3s cubic-bezier(0.49,0.42,0.52,0.98);"], slideOut);
const MenuBkg = styled.div.withConfig({
  displayName: "MobileMenu__MenuBkg",
  componentId: "sc-sx1536-0"
})(["position:fixed;z-index:900;top:0;bottom:0;left:0;width:100vw;background-color:rgb(0 0 0 / 0.75);", ";animation-fill-mode:forwards;", ";"], _ref => {
  let {
    animate
  } = _ref;
  return animate ? appearOutAnimation : appearInAnimation;
}, minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
const menuNotLoggedIn = css(["padding-top:36px;background-color:", ";color:#fff;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.mainColor;
});
const Menu = styled.div.withConfig({
  displayName: "MobileMenu__Menu",
  componentId: "sc-sx1536-1"
})(["display:flex;position:fixed;z-index:900;top:0;bottom:0;right:0;flex-direction:column;overflow:auto;width:", "px;-webkit-overflow-scrolling:touch;box-shadow:0 15px 35px rgb(34 34 90 / 0.1),0 5px 15px rgb(0 0 0 / 0.07),0 1px 3px 1px rgb(34 34 90 / 0.07);background-color:#fff;", ";", ";animation-fill-mode:forwards;", ";"], grid(3), _ref3 => {
  let {
    isLoggedIn
  } = _ref3;
  return !isLoggedIn && menuNotLoggedIn;
}, _ref4 => {
  let {
    animate
  } = _ref4;
  return animate ? slideOutAnimation : slideInAnimation;
}, minMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
const MenuContent = styled.div.withConfig({
  displayName: "MobileMenu__MenuContent",
  componentId: "sc-sx1536-2"
})(["display:flex;flex:1;flex-direction:column;justify-content:space-between;padding-bottom:12px;"]);
const UserInfo = styled.div.withConfig({
  displayName: "MobileMenu__UserInfo",
  componentId: "sc-sx1536-3"
})(["background-color:", ";", ";color:#fff;"], _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.mainColor;
}, fontSmoothing);
const UserData = styled(Flex).withConfig({
  displayName: "MobileMenu__UserData",
  componentId: "sc-sx1536-4"
})(["padding:24px 36px 24px 24px;strong{display:block;", ";font-weight:600;line-height:21px;}small{display:block;", ";}"], getFont(1), getFont(-1, 'compact'));
const Close = styled.div.withConfig({
  displayName: "MobileMenu__Close",
  componentId: "sc-sx1536-5"
})(["position:fixed;z-index:9000;top:9px;right:9px;width:36px;height:36px;padding:6px;cursor:pointer;text-align:center;svg{position:relative;z-index:1;}", ";"], minMediaQueries.tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
const Access = styled.div.withConfig({
  displayName: "MobileMenu__Access",
  componentId: "sc-sx1536-6"
})(["padding:24px 24px 12px;", "{width:100%;margin-left:0;}"], AccessButton);
export class MobileMenu extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hide: false
    });
    _defineProperty(this, "hideMenu", () => {
      this.setState({
        hide: true
      }, () => setTimeout(this.props.toggleMobileMenu, 300));
    });
  }
  render() {
    const {
      user,
      menuRef,
      finectApp
    } = this.props;
    const {
      hide
    } = this.state;
    const {
      isLoggedIn
    } = user || {};
    return React.createElement(Fragment, null, React.createElement(MenuBkg, {
      onClick: this.hideMenu,
      animate: hide
    }), React.createElement(Menu, {
      ref: menuRef,
      isLoggedIn: isLoggedIn,
      animate: hide
    }, React.createElement(Fragment, null, isLoggedIn ? React.createElement(UserInfo, null, React.createElement(Close, {
      onClick: this.hideMenu
    }, React.createElement(X, {
      strokeWidth: "2.2",
      size: "20"
    })), React.createElement(UserData, {
      align: "flex-end"
    }, React.createElement(Icon, {
      alt: user.displayName,
      image: user.icon ? "/image/".concat(user.icon) : '',
      margin: "0 18px 0 0",
      fill: "rgba(255,255,255,0.1)",
      size: 3,
      verified: user.isAdviser,
      inverted: true
    }), React.createElement("div", null, React.createElement("strong", null, user.displayName.length > 24 ? "".concat(user.displayName.slice(0, 21), "...") : user.displayName), user.alias !== user.displayName && React.createElement("small", null, "@", user.alias)))) : React.createElement(Close, {
      onClick: this.hideMenu
    }, React.createElement(X, {
      strokeWidth: "2.2",
      size: "20"
    })), React.createElement(MenuContent, null, React.createElement(UserMenu, {
      mobile: true,
      user: user,
      finectApp: finectApp,
      onItemClick: () => {
        this.hideMenu();
      }
    })))));
  }
}